import * as _m0 from "protobufjs/minimal";
import { SendMessageRequest, SendMessageResponse } from "../sendmessage"; // Assumes generated file exists
import { withAuthRetry } from '../utils/authRetry';

export async function sendmessage(request: SendMessageRequest, accessToken: string, setAccessToken: (token: string | null) => void, logout: () => void): Promise<SendMessageResponse> {
    const originalApiCall = async (token: string): Promise<Response> => {
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        };

        const encodedRequest = SendMessageRequest.encode(request).finish();
        const base64 = _m0.util.base64.encode(encodedRequest, 0, encodedRequest.length);

        const params = new URLSearchParams(window.location.search);
        const staging = params.get('stagingEnv') === 'true';

        let url = "https://li68ja5qo4.execute-api.us-west-2.amazonaws.com/intakeservice/sendmessage";
        if (staging) {
            url = `${url}-staging`;
        }

        const response = await fetch(
            url, {
            method: 'POST',
            headers,
            body: base64,
        }
        );
        return response;
    };

    const decodeResponse = (bytes: Uint8Array): SendMessageResponse => {
        return SendMessageResponse.decode(bytes);
    };

    return withAuthRetry(originalApiCall, accessToken, decodeResponse, setAccessToken, logout);
}
